// extracted by mini-css-extract-plugin
export var card = "_7j-0";
export var expandedCard = "_7j-2";
export var paginated = "_7j-1";